module.exports = __webpack_public_path__ + "img/sprite-1.1bd3e3e0.webp";